<div class="recipient-selector">

    <div class="accordion" id="recipientsAccordion">
        <div class="accordion-item">
            <h2 class="accordion-header" id="recipientsAccordionHeader">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                    [class.collapsed]="!isExpanded()"
                    data-bs-target="#recipientsAccordionCollapse" [attr.aria-expanded]="isExpanded()"
                    aria-controls="recipientsAccordionCollapse"
                    (click)="toggleExpanded()">
                    <span class="recipients-label flex-shrink-0 pe-3">Recipients:</span>
                    @if (!isExpanded()) {
                        @if (activeSelectedCount() > 0) {
                            <span class="badge bg-primary rounded-pill flex-shrink-0 me-3">{{ activeSelectedCount() | number }}</span>
                        }
                        @if (collapsedSummary()) {
                            <span class="text-truncate flex-grow-1 min-w-0 fw-normal">{{ collapsedSummary() }}</span>
                        }
                    }
                </button>
            </h2>
            <div id="recipientsAccordionCollapse" class="accordion-collapse collapse"
                [class.show]="isExpanded()"
                aria-labelledby="recipientsAccordionHeader">
                <div class="accordion-body">

                    <!-- Mode toggle: members and properties are mutually exclusive -->
                    <div class="btn-group mb-4" role="group" aria-label="Recipient type">
                        <button
                            type="button"
                            class="btn"
                            [class.btn-primary]="mode() === RecipientMode.Members"
                            [class.btn-ms-secondary]="mode() !== RecipientMode.Members"
                            (click)="setMode(RecipientMode.Members)">
                            <fa-duotone-icon icon="users" class="me-2" secondaryOpacity="0.9" />
                            Members
                        </button>
                        <button
                            type="button"
                            class="btn"
                            [class.btn-primary]="mode() === RecipientMode.Properties"
                            [class.btn-ms-secondary]="mode() !== RecipientMode.Properties"
                            (click)="setMode(RecipientMode.Properties)">
                            <fa-duotone-icon icon="house" class="me-2" secondaryOpacity="0.2" />
                            Properties
                        </button>
                    </div>

                    <!-- Selected recipients summary (full width, above the list) -->
                    <div class="card mb-3 selected-recipients-panel">
                        <div class="card-body py-3">
                            <h6 class="mb-2">
                                Selected
                                <span class="badge bg-primary ms-1">{{ activeSelectedCount() | number }}</span>
                            </h6>

                            @if (isSelectAllActive()) {
                                <p class="mb-2">
                                    <fa-duotone-icon icon="circle-check" class="text-primary me-2" secondaryOpacity="0.9" />
                                    All {{ activeSelectedCount() | number }} {{ recipientTypeLabel() }} matching the current filter.
                                </p>
                                @if (selectedRecipients().length > 0) {
                                    <p class="text-muted small mb-2">Excluded (click to re-include):</p>
                                    <div class="d-flex flex-wrap">
                                        @for (recipient of selectedRecipients(); track recipient.id) {
                                            <button type="button"
                                                class="tag-filter btn btn-ms-secondary"
                                                (click)="removeRecipient(recipient.id)"
                                                [attr.aria-label]="'Re-include ' + recipient.label">
                                                {{ recipient.label }}
                                                <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                                            </button>
                                        }
                                    </div>
                                }
                            } @else if (selectedRecipients().length === 0) {
                                <p class="text-muted mb-0">No {{ recipientTypeLabel() }} selected yet.</p>
                            } @else {
                                <div class="d-flex flex-wrap">
                                    @for (recipient of selectedRecipients(); track recipient.id) {
                                        <button type="button"
                                            class="tag-filter btn btn-primary"
                                            (click)="removeRecipient(recipient.id)"
                                            [attr.aria-label]="'Remove ' + recipient.label">
                                            {{ recipient.label }}
                                            <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Recipient list (full width) -->
                    @if (mode() === RecipientMode.Members) {
                        <ms-communications-member-selector
                            [organizationId]="organizationId()"
                            (selectionChanged)="onMemberSelectionChanged($event)">
                        </ms-communications-member-selector>
                    } @else {
                        <ms-communications-property-selector
                            [organizationId]="organizationId()"
                            (selectionChanged)="onPropertySelectionChanged($event)">
                        </ms-communications-property-selector>
                    }

                </div>
            </div>
        </div>
    </div>
</div>
